import type { GameComponentProps } from '../core/types';
import { FixtureGame } from '../fixture/FixtureGame';
import { RatioleGame } from './RatioleGame';

export function RatioleEntry(props: GameComponentProps) {
  if (props.puzzle.generatorVersion < 2) return <FixtureGame {...props} />;
  return <RatioleGame {...props} />;
}
